import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import {RouterLink} from '@angular/router';
import {Entity} from '../entity/entity';
import {Opportunity} from './opportunity';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatButton} from '@angular/material/button';
import { CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common';

@Component({
    selector: 'associated-quotes-dialog',
    templateUrl: 'associated-quotes-dialog.component.html',
    styleUrls: ['./associated-quotes-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, MatButton, DecimalPipe, CurrencyPipe, DatePipe]
})
export class AssociatedQuotesDialogComponent {
  dialogRef = inject<MatDialogRef<AssociatedQuotesDialogComponent>>(MatDialogRef);
  private data = inject(MAT_DIALOG_DATA);


  public isBusy: boolean = false;
  public quotes: Entity[];
  public selectedQuote!: Entity;
  public opportunity: Opportunity;

  constructor
  () {
    this.isBusy = true;
    this.quotes = this.data.quotes as Entity[];
    this.opportunity = this.data.opportunity as Opportunity;
    this.isBusy = false;
  }

  public close(): void {
    this.dialogRef.close(false);
  }

  public selectAssociatedQuote(quote: Entity) {
    this.selectedQuote = quote;
  }

  public applyQuote() {
    if (this.selectedQuote) {
      this.opportunity.associatedQuoteId = this.selectedQuote.id.entityId + ";" + this.selectedQuote.id.entityRevision;
    }
    this.close();
  }
}
